"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AgendaSlotReservationsHttpService = void 0;
const confirm_agenda_slot_reservation_1 = require("../../types/agenda-slot-reservations/confirm-agenda-slot-reservation");
const confirm_agenda_slot_reservation_many_1 = require("../../types/agenda-slot-reservations/confirm-agenda-slot-reservation-many");
const decline_agenda_slot_reservation_1 = require("../../types/agenda-slot-reservations/decline-agenda-slot-reservation");
const decline_agenda_slot_reservation_many_1 = require("../../types/agenda-slot-reservations/decline-agenda-slot-reservation-many");
const http_service_1 = require("../http.service");
class AgendaSlotReservationsHttpService extends http_service_1.HttpService {
    constructor(apiUrl) {
        super(`${apiUrl}/agenda-slot-reservations`);
    }
    confirmById(id, body) {
        return this.postEntity(`${id}/confirm`, {
            body,
            schema: confirm_agenda_slot_reservation_1.confirmAgendaSlotReservationApiResponseSchema,
        });
    }
    updateTag(id, body) {
        return this.putEntity(`${id}/tag`, {
            body,
            schema: confirm_agenda_slot_reservation_1.confirmAgendaSlotReservationApiResponseSchema,
        });
    }
    confirmByIds(ids) {
        const body = {
            ids,
        };
        return this.post(`confirm-many`, {
            body,
            schema: confirm_agenda_slot_reservation_many_1.confirmAgendaSlotReservationManyApiResponseSchema,
        });
    }
    declineById(id) {
        return this.post(`${id}/decline`, {
            schema: decline_agenda_slot_reservation_1.declineAgendaSlotReservationApiResponseSchema,
        });
    }
    declineByIds(ids) {
        const body = {
            ids,
        };
        return this.post(`decline-many`, {
            body,
            schema: decline_agenda_slot_reservation_many_1.declineAgendaSlotReservationManyApiResponseSchema,
        });
    }
}
exports.AgendaSlotReservationsHttpService = AgendaSlotReservationsHttpService;
